import {useCallback, useState} from "react"
import {Filters} from "../../models/Filter"
import {FacetsState} from "../../models/FacetsState"
import TrackViewAllModalSearchBar from "../../events/trackEvent/events/viewAllModalSearchBar"

export const useAutocompleteFacetSearch = (
    facets: FacetsState,
    filters: Filters,
    handleSetFacetModal: (facetValue: string) => void,
) => {
    const [inputString, setInputString] = useState("")
    const [facetValue, getFilterValueState] = useState(null)

    const setSearchString = useCallback((_event, value: string): void => setInputString(value), [setInputString])
    const setFacetValue = useCallback(
        (_event, selectedFacet): void => {
            if (
                Object.prototype.hasOwnProperty.call(selectedFacet, "v") &&
                Object.prototype.hasOwnProperty.call(facets, selectedFacet.v) &&
                !facets[selectedFacet.v].s
            ) {
                // eslint-disable-next-line prettier/prettier
                const selectedFilterFacetCombination = `${filters[selectedFacet.v.split(":")[0]].displayName}: ${
                    selectedFacet.n as string
                }`
                handleSetFacetModal(selectedFacet.v)
                TrackViewAllModalSearchBar(selectedFilterFacetCombination)
            }
            setInputString("")
            getFilterValueState(null)
        },
        [facets, handleSetFacetModal, setInputString, getFilterValueState],
    )

    return {facetValue, inputString, setSearchString, setFacetValue}
}
